import { Button } from '@mui/material';
import useSport from 'store/sport';
import useTranslates from 'utils/translate';

const NineWickets = ({ sportId }: { sportId: string }) => {
  const [sportState, { withdraw }] = useSport();
  const { translate } = useTranslates();

  return (
    <>
      {sportState.data[sportId] && (
        <>
          <iframe
            src={`${sportState.data[sportId].url}&token=${sportState.data[sportId].token}`}
            style={{ width: '100%', border: 0, height: 20, opacity: 0 }}
          />
          <Button
            style={{
              position: 'relative',
              left: '50%',
              top: '200px',
            }}
            variant="contained"
            size="large"
            onClick={() => withdraw(Number(sportId))}
          >
            {translate('withdraw_from_nine_wickets')}
          </Button>
        </>
      )}
    </>
  );
};

export default NineWickets;
